import { productFamilyCodes } from 'types/productFamilyCodes';

export const publicFare = {
  productFamilies: productFamilyCodes.PUB
};

export const packageBookingFares = [productFamilyCodes.PUB, productFamilyCodes.RIT];
